module.exports = __webpack_public_path__ + "build/desktop/a/img/checkboxMedium.8f519bfb03a5ce60ca4341cd332a5171.svg";